import Servicios from "../../Components/Servicios/Servicios";
import { serviciosSistemas } from "../../Data/serviciosSistemas";

function Sistemas() {
  return (
    <Servicios
      etiqueta="SISTEMAS Y PROCESOS"
      
      titulo="De datos desordenados a procesos que funcionan."
      
      subtitulo="Ordenamos Excel, productos, imágenes y bases de datos para convertir procesos manuales en sistemas más simples y eficientes."
      
      servicios={serviciosSistemas.servicios}
      
      background={serviciosSistemas.background}
    />
  );
}

export default Sistemas;